import React from "react";

import mainStyle from "../../dashboard.module.scss";
import { styled, useTheme } from '@mui/material/styles';
import { Grid, Divider, Box, Typography } from "@mui/material";

import { ReactComponent as Internet } from "assets/images/icons/icn_dashboard_internet.svg";
import { ReactComponent as Router } from "assets/images/icons/icn_dashboard_gateway.svg";
import { ReactComponent as Switch } from "assets/images/icons/icn_dashboard_switch.svg";
import { ReactComponent as AP } from "assets/images/icons/icn_dashboard_ap.svg";
import { ReactComponent as Client } from "assets/images/icons/icn_dashboard_client.svg";

import icn_site_network from "assets/images/icons/icn_site_network.svg";

const commonFlexStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const CommonTypography = styled(Typography)(({ theme }) => ({
  margin: 0,
  color: theme.palette.primary.greyPrimary,
  fontWeight: theme.typography.customFontWeight[3],
}));

const DividerWithDots = () => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "170%",
        paddingBottom: "20px",
      }}
    >
      <span
        style={{
          width: "5px",
          height: "5px",
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
        }}
      ></span>
      <div
        style={{
          flexGrow: 1,
          height: "2px",
          backgroundColor: theme.palette.primary.main,
        }}
      ></div>
      <span
        style={{
          width: "5px",
          height: "5px",
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
        }}
      ></span>
    </div>
  );
}

const NetworkStatus = ({ sortable, routerData, switchData, apData, clientData }) => {
  const theme = useTheme();

  return (
    <div
      style={{ minHeight: "250px" }}
      className={`main-card-content ${mainStyle["dndObj_card"]}
        ${sortable === true ? mainStyle["dndObj_edit"] : ""}
      `}
    >
      <div className={mainStyle["dndObj_title"]}>
        <img src={icn_site_network} alt="dashboard_network_icon" />
        <span style={{ marginLeft: "10px" }}>Site network status</span>
      </div>
      <Box>
        <Grid item xs={12} style={{ marginTop: "10px" }}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={1.5} style={commonFlexStyle}>
              <Internet />
              <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], lineHeight: 0.95 }}>
                Internet
              </Typography>
            </Grid>
            <Grid item xs={1} style={commonFlexStyle}>
              <DividerWithDots />
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}>
              <Router />
              <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], lineHeight: 0.95 }}>
                Routers
              </Typography>
            </Grid>
            <Grid item xs={1} style={commonFlexStyle}>
              <DividerWithDots />
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}>
              <Switch />
              <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], lineHeight: 0.95 }}>
                Switches
              </Typography>
            </Grid>
            <Grid item xs={1} style={commonFlexStyle}>
              <DividerWithDots />
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}>
              <AP />
              <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], lineHeight: 0.95 }}>
                Access Points
              </Typography>
            </Grid>
            <Grid item xs={1} style={commonFlexStyle}>
              <DividerWithDots />
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}>
              <Client />
              <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], lineHeight: 0.95 }}>
                Clients
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ marginTop: "10px" }}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={1.25} style={commonFlexStyle}></Grid>
            <Grid item xs={1.25} style={commonFlexStyle}></Grid>
            <Grid
              item
              xs={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
                paddingRight: "10px",
              }}
            >
              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Online
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greenPrimary" }}>
                  {routerData?.online ?? 0}
                </CommonTypography>{" "}
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Offline
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greyThird" }}>
                  {routerData?.offline ?? 0}
                </CommonTypography>{" "}
              </div>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ borderColor: "primary.greyThread", borderWidth: 1 }}
              />

              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Total
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[3], fontWeight: theme.typography.customFontSize[1] }}>
                  {routerData?.online + routerData?.offline}
                </CommonTypography>
              </div>
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}></Grid>
            <Grid
              item
              xs={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
                paddingRight: "10px",
              }}
            >
              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Online
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greenPrimary" }}>
                  {switchData.online}
                </CommonTypography>{" "}
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Offline
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greyThird" }}>
                  {switchData.offline}
                </CommonTypography>{" "}
              </div>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ borderColor: "primary.greyThread", borderWidth: 1 }}
              />

              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Total
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[3], fontWeight: theme.typography.customFontSize[1] }}>
                  {switchData.online + switchData.offline}
                </CommonTypography>
              </div>
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}></Grid>
            <Grid
              item
              xs={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
                paddingRight: "10px",
              }}
            >
              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Online
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greenPrimary" }}>
                  {apData.online}
                </CommonTypography>{" "}
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Offline
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greyThird" }}>
                  {apData.offline}
                </CommonTypography>{" "}
              </div>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ borderColor: "primary.greyThread", borderWidth: 1 }}
              />

              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Total
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[3], fontWeight: theme.typography.customFontSize[1] }}>
                  {apData.online + apData.offline}
                </CommonTypography>
              </div>
            </Grid>
            <Grid item xs={1.5} style={commonFlexStyle}></Grid>
            <Grid
              item
              xs={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
                paddingRight: "10px",
              }}
            >
              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Online
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greenPrimary" }}>
                  {clientData.online}
                </CommonTypography>{" "}
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Offline
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greyThird" }}>
                  {clientData.offline}
                </CommonTypography>{" "}
              </div>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ borderColor: "primary.greyThread", borderWidth: 1 }}
              />

              <div style={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Total
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[3], fontWeight: theme.typography.customFontSize[1] }}>
                  {clientData.online + clientData.offline}
                </CommonTypography>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default NetworkStatus
